module.exports = __webpack_public_path__ + "img/banner-452.bb2a89de.png";